import './index.scss';

import React from 'react';

import Monogram from '@components/Monogram';

import chevronRight from 'url:@icon/chevron.right.plain.svg'

export type PersonCardProps = {
  name: string;
  email?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function PersonCard(props: PersonCardProps) {
  const content = <>
    <Monogram name={props.name} />

    <div className='text'>
      <p className='name'>{props.name}</p>
      {props.email && <p className='email'>{props.email}</p>}
    </div>

    <img className='chevron' src={chevronRight} alt='>' />
  </>;

  if (!props.onClick) {
    return <div className='person-card card'>{content}</div>;
  }

  return (
    <button type='button' className='person-card card is-interactive' onClick={props.onClick}>
      {content}
    </button>
  );
}
